import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { invalidateKeys, queryKeys } from '@/lib/query-keys';

import type { OrganizationPackage, UpdatePackageInput } from '../types';

/**
 * `PUT /packages/:id` — the package's own fields. Its services are separate
 * endpoints (`useSyncPackageItems`), so the editor saves both and raises one
 * success toast itself; this hook only reports failure.
 */
export const useUpdatePackage = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      packageId,
      ...input
    }: UpdatePackageInput & { packageId: string }) =>
      apiClient.put<OrganizationPackage>(`packages/${packageId}`, input),
    onSuccess: () => {
      invalidateKeys(queryClient, queryKeys.packages.all());
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update package');
    },
  });

  return {
    updatePackageAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
  };
};
